"use strict";
exports.__esModule = true;
exports.isEmpty = void 0;
var isEmpty = function (value) {
    return value === undefined ||
        value === null ||
        value === '' ||
        Number.isNaN(value) ||
        (value instanceof Object && Object.entries(value).length === 0) ||
        (Array.isArray(value) && value.length === 0);
};
exports.isEmpty = isEmpty;
//# sourceMappingURL=isEmpty.js.map